import { render, staticRenderFns } from "./GTubeDetail.vue?vue&type=template&id=4a1cf0fc&"
import script from "./GTubeDetail.vue?vue&type=script&lang=js&"
export * from "./GTubeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports